import { AccountDateFilterRequest } from '../../../_shared/models/account-date-filter-request.model';

export interface AssetCostTableRequest extends AccountDateFilterRequest {
  page: number;
  pageSize: number;
  searchTerm?: string;
}

export interface BudgetCategory {
  id: number;
  name: string;
}

/** Transloco namespace that translates backend budget category names by slug (see lookupLabel). */
export const BUDGET_CATEGORY_LABELS = 'costTracking.budgetCategories';

export interface Asset {
  id: number;
  name: string;
}

export interface BudgetTableRequest {
  page: number;
  pageSize: number;
  accountIds: number[];
  searchTerm?: string;
  budgetCategoryId?: number | null;
}

export interface CreateBudgetsRequest {
  assetIds: number[];
  budgetCategoryId: number;
  annualBudget: number;
  monthlyBudget: number;
  notes?: string | null;
}

export interface UpdateBudgetRequest {
  budgetCategoryId: number;
  annualBudget: number;
  monthlyBudget: number;
  notes?: string | null;
}
